import React from "react";
import { NavLink } from "react-router-dom";

function ProfileMenu({ match, assessments = [], admitted = false }) {
    const phys = [
        {
            title: "Food Intake",
            path: "food-fluid",
            icon: "fa-spoon",
        },
        {
            title: "Fluid Intake",
            path: "fluid-intake",
            icon: "fa-glass",
        },
        {
            title: "Health Blood",
            path: "health-blood",
            icon: "fa-tint",
        },
        {
            title: "Health Glucose Monitoring",
            path: "glucose-monitoring",
            icon: "fa-user-circle",
        },
        {
            title: "Drug Chart",
            path: "drug-chart",
            icon: "fa-user-circle",
        },
        {
            title: "Patient Vitals",
            path: "vital",
            icon: "fa-user-md",
        },
        {
            title: "Malnutrition tool-BMI",
            path: "ibm-tool",
            icon: "fa-angle-double-right",
        },
        {
            title: "Body Map",
            path: "body-map",
            icon: "fa-male",
        },
        {
            title: "Health Observation",
            path: "health-observation",
            icon: "fa-cab",
        },
    ];

    return (
        <div className="menu-container">
            <nav className="navbar navbar-expand-lg navbar-light">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#basicExampleNav"
                    aria-controls="basicExampleNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="basicExampleNav">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                exact
                                to={{
                                    pathname: `${match.url}`,
                                }}
                            >
                                <i className="fa fa-list-alt"></i> Patient Summary
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/update-patient`,
                                }}
                            >
                                <i className="fa fa-edit"></i> Update Patient
                            </NavLink>
                        </li>

                        {admitted ? (
                            <li className="nav-item linker">
                                <NavLink
                                    className="nav-link"
                                    to={{
                                        pathname: `${match.url}/discharge-patient`,
                                    }}
                                >
                                    <i className="fa fa-car"></i> Discharge Patient
                                </NavLink>
                            </li>
                        ) : (
                            <li className="nav-item linker">
                                <NavLink
                                    className="nav-link"
                                    to={{
                                        pathname: `${match.url}/admit-patient`,
                                    }}
                                >
                                    <i className="fa fa-bed"></i> Admit Patient
                                </NavLink>
                            </li>
                        )}

                        <li className="nav-item dropdown multi-level-dropdown">
                            <a href="#" id="menu" data-toggle="dropdown" className="nav-link dropdown-toggle w-100">
                                <i className="fa fa-users"></i> Physical Health <i className="fa fa-angle-down"></i>
                            </a>
                            <ul className="dropdown-menu mr-2 rounded-0 primary-color border-0 z-depth-1 r-100">
                                {phys.map((item, idx) => (
                                    <li key={idx} className="dropdown-item p-0">
                                        <NavLink
                                            className="w-100 nav-link"
                                            to={{
                                                pathname: `${match.url}/${item.path}`,
                                            }}
                                        >
                                            <i className={`fa ${item.icon}`}></i> {item.title}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        </li>

                        <li className="nav-item dropdown multi-level-dropdown">
                            <a href="javascript:;" className="nav-link dropdown-toggle w-100" data-toggle="dropdown" aria-expanded="false">
                                <i className="fa fa-user-times"></i> <span>Risk & Security</span>
                                <i className="fa fa-angle-down"></i>
                            </a>
                            <ul className="dropdown-menu mr-2 rounded-0  primary-color border-0 z-depth-1 r-100" role="menu">
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/risk-matrix`,
                                        }}
                                    >
                                        Risk Matrix
                                    </NavLink>
                                </li>
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/risk`,
                                        }}
                                    >
                                        Patient Risk
                                    </NavLink>
                                </li>
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/room-search`,
                                        }}
                                    >
                                        Patient Search
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item dropdown multi-level-dropdown">
                            <a href="javascript:;" className="nav-link dropdown-toggle w-100" data-toggle="dropdown" aria-expanded="false">
                                <i className="fa fa-user-o"></i> <span>Assessment</span>
                                <i className="fa fa-angle-down"></i>
                            </a>
                            <ul className="dropdown-menu" role="menu">
                                {assessments.map((item, idx) => (
                                    <li key={idx} className="dropdown-item p-0">
                                        <NavLink
                                            className="w-100 nav-link"
                                            to={{
                                                pathname: `${match.url}/assessment/${item.id}`,
                                            }}
                                        >
                                            {item.name}
                                        </NavLink>
                                    </li>
                                ))}
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/interest-checklist`,
                                        }}
                                    >
                                        Interest Checklist
                                    </NavLink>
                                </li>
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/short-service-assessment`,
                                        }}
                                    >
                                        Short Term Service
                                    </NavLink>
                                </li>
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/personal-assessment`,
                                        }}
                                    >
                                        Personal Assessment
                                    </NavLink>
                                </li>
                                <li className="dropdown-item p-0">
                                    <NavLink
                                        className="w-100 nav-link"
                                        to={{
                                            pathname: `${match.url}/water-flow-assessment`,
                                        }}
                                    >
                                        Waterlow Ulcer Pressure
                                    </NavLink>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
            <nav className="navbar navbar-expand-lg navbar-light">
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#basicExampleNav2"
                    aria-controls="basicExampleNav2"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="basicExampleNav2">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/incident-record`,
                                }}
                            >
                                <i className="fa fa-sticky-note"></i> Incident Record
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/care-note`,
                                }}
                            >
                                <i className="fa fa-sticky-note"></i> Care Note
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/care-plan`,
                                }}
                            >
                                <i className="fa fa-list-alt"></i> Care Plan
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/timetable`,
                                }}
                            >
                                <i className="fa fa-align-left"></i> Timetable
                            </NavLink>
                        </li>

                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/attachment`,
                                }}
                            >
                                <i className="fa fa-upload"></i> Attachment
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/leave`,
                                }}
                            >
                                <i className="fa fa-unlock"></i> Leave
                            </NavLink>
                        </li>
                        <li className="nav-item linker">
                            <NavLink
                                className="nav-link"
                                to={{
                                    pathname: `${match.url}/activity`,
                                }}
                            >
                                <i className="fa fa-medkit"></i> Patient Activity
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default ProfileMenu;
